import api from './api';
import { User } from '../types/User';

export const userService = {
  async getAllUsers(page: number = 1, limit: number = 10, search?: string): Promise<{
    users: User[];
    pagination: { page: number; limit: number; total: number; pages: number };
  }> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search })
    });
    const response = await api.get(`/users?${params}`);
    return response.data.data;
  },

  async getUserById(id: string): Promise<User> {
    const response = await api.get<{ success: boolean; data: User }>(`/users/${id}`);
    return response.data.data;
  },

  async updateUser(id: string, data: {
    name?: string;
    role?: string;
    avatar?: string;
    credits?: number;
  }): Promise<User> {
    const response = await api.put<{ success: boolean; data: User }>(`/users/${id}`, data);
    return response.data.data;
  },

  async deleteUser(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  }
};
